export default "__VITE_ASSET__70d04d43__"